import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthProvider } from "./providers/AuthProvider";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";

import FourOhFour from "./pages/404";
import Home from "./pages/Home";
import NoPermission from "./pages/NoPermission";

import Schedule from "./components/pages/schedule/Schedule";
import SchedulePage from "./pages/schedule/SchedulePage";

import Vetro from "./components/pages/vetro/Vetro";
import VetroPage from "./pages/vetro/VetroPage";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export default function RoutedApp() {
    return(
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <Routes>
                        {/* Home page is also protected */}
                        <Route path="/" element={
                            <ProtectedRoute>
                                <Home />
                            </ProtectedRoute>
                        } />

                        {/* Scheduling */}
                        <Route path="/schedule" element={
                            <ProtectedRoute>
                                <SchedulePage title="Scheduling Timeline">
                                    <Schedule userId={null}/>
                                </SchedulePage>
                            </ProtectedRoute>
                        } />

                        {/* Vetro */}
                        <Route path="/vetro" element={
                            <ProtectedRoute>
                                <VetroPage title="Vetro File Uploader">
                                    <Vetro />
                                </VetroPage>
                            </ProtectedRoute>
                        } />

                        {/* Auth routes should NOT be protected */}
                        <Route path="/auth/*" element={<Navigate to="/auth/login" replace />} />

                        {/* No-permission page — must remain unprotected so role-less users can reach it */}
                        <Route path="/no-permission" element={<NoPermission />} />

                        {/* Even 404 should be protected */}
                        <Route path="*" element={
                            <ProtectedRoute>
                                <FourOhFour />
                            </ProtectedRoute>
                        } />
                    </Routes>
                </AuthProvider>
            </QueryClientProvider>
        </BrowserRouter>
    )
}